/**
 * Created by zhaoxu on 2018/6/25.
 */
import bus from '@/data/event-bus';
import GlobalEvents from '@/enums/global-events'

export default function install(Vue) {
  Vue.prototype.$dialog = function (dialogObj) {
    bus.$emit(GlobalEvents.DIALOG, dialogObj);
  }
}